import { AuthService } from '@core/services/auth'

const AMSLoginRoute = () => {
    AuthService.login().catch(console.error)

    return null
}

export default AMSLoginRoute
